import { render, staticRenderFns } from "./PageChooser.vue?vue&type=template&id=031812e0&scoped=true&"
import script from "./PageChooser.vue?vue&type=script&lang=js&"
export * from "./PageChooser.vue?vue&type=script&lang=js&"
import style0 from "./PageChooser.vue?vue&type=style&index=0&id=031812e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031812e0",
  null
  
)

export default component.exports